var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 194,
    viewBox: "0 0 186 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_4533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36239 73.5544L180.982 72.25L185.987 193.999L0 192.278L1.36239 73.5544Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3623 73.5551L92.5615 0L180.982 72.2508",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3623 73.5551L92.5615 0L180.982 72.2508",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000224665 192.28C-0.229538 192.064 14.1497 176.412 32.1171 157.331C50.0845 138.236 64.828 122.92 65.0438 123.135C65.2731 123.35 50.8938 138.989 32.9265 158.097C14.9726 177.179 0.229089 192.481 -0.000224665 192.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.986 193.998C185.757 194.2 171.755 178.871 154.705 159.749C137.655 140.627 124.031 124.961 124.261 124.76C124.49 124.558 138.492 139.888 155.542 159.009C172.578 178.131 186.216 193.797 185.986 193.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.982 72.25L90.7945 144.084L1.3623 73.5544",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4135 80.2152L10.1572 28.1215L167.466 24.2891L169.179 81.2775L90.7811 143.147L10.4135 80.2152Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9796 124.436C91.4958 124.436 89.9985 124.356 88.5012 124.181C78.1147 123.011 68.8073 117.874 62.2921 109.725C55.7769 101.577 52.8363 91.3837 54.0233 81.0295C56.4513 59.6488 75.8755 44.225 97.3231 46.6589C107.71 47.8288 117.017 52.9656 123.532 61.1145C130.047 69.2634 132.988 79.4562 131.801 89.8104C130.627 100.165 125.475 109.443 117.3 115.938C110.299 121.492 101.815 124.436 92.9931 124.436H92.9796ZM92.8717 47.7482C73.9196 47.7482 57.5305 61.9751 55.3587 81.1774C54.2257 91.182 57.0583 101.012 63.3442 108.892C69.6301 116.758 78.6138 121.72 88.6496 122.85C98.672 123.993 108.546 121.155 116.45 114.889C124.342 108.623 129.319 99.6671 130.452 89.6625C131.585 79.6579 128.752 69.8281 122.467 61.9482C116.181 54.0817 107.197 49.1197 97.1612 47.9902C95.7179 47.8288 94.288 47.7482 92.8852 47.7482H92.8717Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2979 90.8354L72.84 82.8479L88.1366 93.861L112.997 64.6406L120.497 71.2162L88.5277 107.953L66.2979 90.8354Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_4533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 194,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ef9fc7aa5859e99e94a1d8c12939d78e.svg";
export { ForwardRef as ReactComponent };